import React from 'react';
import { Input } from '@/components/ui/Input';
import { Badge } from '@/components/ui/Badge';
import { Card } from '@/components/ui/Card';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const { FiFilter, FiMapPin, FiAward, FiClock, FiX } = FiIcons;

const selectClass = "h-11 px-4 rounded-xl border-2 border-surface-200 text-[11px] font-bold bg-white focus:border-primary-400 outline-none text-surface-700 appearance-none disabled:opacity-50 transition-all cursor-pointer hover:border-surface-300";

const UsersFilters = ({ filters, filterOptions, isSearchActive, onChange, onReset }) => {
  const { filterStatus, filterState, filterGift, filterSlab, dateFrom, dateTo } = filters;

  const hasActiveFilter = filterGift || filterState || filterStatus || filterSlab || dateFrom || dateTo;

  const set = (key) => (e) => onChange(key, e.target.value);

  return (
    <Card className="border-none shadow-sm bg-white/50 backdrop-blur-sm p-4 overflow-visible rounded-[1.5rem]">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-7 gap-3">
        {/* Status Filter */}
        <div className="relative xl:col-span-1">
          <select 
            className={`${selectClass} w-full`}
            value={filterStatus}
            onChange={set('filterStatus')}
            disabled={isSearchActive}
          >
            <option value="">Status: All</option>
            <option value="pending">Pending</option>
            <option value="gift_selected">Gift Selected</option>
            <option value="address_completed">Address Completed</option>
            <option value="shop_name_mismatched">Shop Name Mismatch</option>
            <option value="not_shop_owner">Not Shop Owner</option>
          </select>
          <SafeIcon icon={FiFilter} className="absolute right-4 top-1/2 -translate-y-1/2 w-3 h-3 text-surface-300 pointer-events-none" />
        </div>

        <div className="relative xl:col-span-1">
          <select 
            className={`${selectClass} w-full`}
            value={filterState}
            onChange={set('filterState')}
            disabled={isSearchActive}
          >
            <option value="">State: All</option>
            {filterOptions?.states?.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
          <SafeIcon icon={FiMapPin} className="absolute right-4 top-1/2 -translate-y-1/2 w-3 h-3 text-surface-300 pointer-events-none" />
        </div>

        <div className="relative xl:col-span-1">
          <select 
            className={`${selectClass} w-full`}
            value={filterGift}
            onChange={set('filterGift')}
            disabled={isSearchActive}
          >
            <option value="">Gift: All</option>
            {filterOptions?.gifts?.map(g => <option key={g} value={g}>{g}</option>)}
          </select>
          <SafeIcon icon={FiAward} className="absolute right-4 top-1/2 -translate-y-1/2 w-3 h-3 text-surface-300 pointer-events-none" />
        </div>

        <div className="relative xl:col-span-1">
          <select 
            className={`${selectClass} w-full`}
            value={filterSlab}
            onChange={set('filterSlab')}
            disabled={isSearchActive}
          >
            <option value="">Slab: All</option>
            {filterOptions?.slabs?.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
          <SafeIcon icon={FiFilter} className="absolute right-4 top-1/2 -translate-y-1/2 w-3 h-3 text-surface-300 pointer-events-none" />
        </div>

        <div className="flex items-center gap-2 bg-white px-2 rounded-xl border-2 border-surface-200 min-w-0 xl:col-span-3">
          <SafeIcon icon={FiClock} className="w-3 h-3 text-surface-400 ml-1 shrink-0" />
          <Input 
            type="date" 
            className="h-8 border-none bg-transparent text-[10px] font-bold w-full focus:ring-0 p-0 min-w-0"
            value={dateFrom}
            onChange={set('dateFrom')}
            disabled={isSearchActive}
          />
          <span className="text-surface-300 text-[9px] font-black uppercase shrink-0">To</span>
          <Input 
            type="date" 
            className="h-8 border-none bg-transparent text-[10px] font-bold w-full focus:ring-0 p-0 min-w-0"
            value={dateTo}
            min={dateFrom}
            onChange={set('dateTo')}
            disabled={isSearchActive || !dateFrom}
          />
        </div>
      </div>

      {hasActiveFilter && (
        <div className="mt-4 pt-4 border-t border-surface-100 flex items-center justify-between">
          <Badge variant="neutral" className="bg-surface-100/50 text-surface-500 font-black text-[9px] uppercase tracking-widest px-3">Active Filtering</Badge>
          <button 
            onClick={onReset}
            className="text-[10px] font-black text-red-500 uppercase flex items-center hover:opacity-70"
          >
            <SafeIcon icon={FiX} className="w-3 h-3 mr-1" />
            Reset All Filters
          </button>
        </div>
      )}
    </Card>
  );
};

export default UsersFilters;